import { gql } from '@apollo/client';
export const EMPLOYEE_SNAPSHOT_FRAGMENT = gql `
  fragment EmployeeSnapshotFields on GeneratedEmployeeSnapshot {
    id
    clientId
    employeeId
    snapshotDate
    employeeData
  }
`;
export const EMPLOYEE_SNAPSHOTS = gql `
  ${EMPLOYEE_SNAPSHOT_FRAGMENT}
  query EMPLOYEE_SNAPSHOTS($spec: EmployeeSnapshotSpec!) {
    employeeSnapshots(spec: $spec) {
      total
      page
      pageSize
      items {
        ...EmployeeSnapshotFields
      }
    }
  }
`;
